module.exports = __webpack_public_path__ + "media/application/images/2018/2018-dir-red-lock-0697f62113c556745a643977ac283a69.svg";